import * as React from 'react';
import { AdsSwappingContext } from 'src/common/stores/contexts/adsSwapping/ads-swapping-context';
export const ResultsWithScrollForAdsSwapping = React.memo(({
  children
}) => {
  const {
    handleScroll
  } = React.useContext(AdsSwappingContext);
  // When EGDSScrollable will be extended by some extra props we can use that here instead the div:
  // <EGDSScrollable style={{ position: 'relative' }} onScroll={handleScroll}>
  return React.createElement("div", {
    style: {
      overflowY: 'auto',
      blockSize: '100%',
      position: 'relative'
    },
    onScroll: handleScroll
  }, children);
});